import { ref } from 'vue'
import { projectAuth } from '@/firebase/config'

const user = ref(null)

const isLoadingAuth = ref(true)

const getUser = () => {
  projectAuth.onAuthStateChanged((firebaseUser) => {
    user.value = firebaseUser
    isLoadingAuth.value = false
  })

  return { user, isLoadingAuth }
}

export default getUser